module.exports = __webpack_public_path__ + "img/schellen33.04876e33.png";